import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import { Styled } from './LightBoxFooter.styles';
const buttonVariantMapping = {
    premium: 'premium',
    projobs: 'proJobs',
    probusiness: 'proBusiness',
    primary: 'primary',
};
const LightBoxFooter = ({ buttons, buttonColor, onClick, onClose, }) => {
    var _a;
    const forwardButtonStyle = {
        variant: buttonVariantMapping[(_a = buttonColor === null || buttonColor === void 0 ? void 0 : buttonColor.toLowerCase()) !== null && _a !== void 0 ? _a : 'primary'],
    };
    return (_jsx(Styled.Container, { children: buttons.map((button) => {
            return button.clickAction === 'CLOSE' ? (_jsx(Styled.StyledTextButton, { "data-test-id": "lightbox-footer-button", size: "medium", onClick: onClose, children: (button === null || button === void 0 ? void 0 : button.text) || _jsx(FormattedMessage, { id: "BUTTON_CLOSE" }) })) : (buttonColor === null || buttonColor === void 0 ? void 0 : buttonColor.toLowerCase()) === 'black' ? (_jsx(Styled.BlackButton, { "data-test-id": "lightbox-footer-button", size: "medium", onClick: onClick, children: (button === null || button === void 0 ? void 0 : button.text) || _jsx(FormattedMessage, { id: "BUTTON_FORWARD" }) })) : (_jsx(Styled.StyledButton, { ...forwardButtonStyle, "data-test-id": "lightbox-footer-button", size: "medium", onClick: onClick, children: (button === null || button === void 0 ? void 0 : button.text) || _jsx(FormattedMessage, { id: "BUTTON_FORWARD" }) }));
        }) }));
};
export { LightBoxFooter };
//# sourceMappingURL=LightBoxFooter.js.map